import React from "react";
import { ClipboardCheck, Timer, CircleCheckBig, X, Eye } from "lucide-react";

const STATS = [
  {
    label: "Pending Requests",
    value: "12",
    Icon: Timer,
    tone: "orange",
  },
  {
    label: "Approved",
    value: "44",
    Icon: CircleCheckBig,
    tone: "green",
  },
  {
    label: "Rejected",
    value: "7",
    Icon: X,
    tone: "red",
  },
];

const ROWS = [
  {
    type: "Leave Request",
    employee: "John Smith",
    duration: "3 Days",
    fromTo: "12/20/2024 - 12/22/2024",
    status: "Pending",
    badge: "pending",
  },
  {
    type: "Complain",
    employee: "Sarah Johnson",
    duration: "N/A",
    fromTo: "12/15/2024 - 12/15/2024",
    status: "Pending",
    badge: "pending",
  },
  {
    type: "Leave Request",
    employee: "Mike Davis",
    duration: "1 Day",
    fromTo: "12/18/2024 - 12/18/2024",
    status: "Approved",
    badge: "approved",
  },
  {
    type: "Work From Home",
    employee: "Emily Brown",
    duration: "2 Days",
    fromTo: "12/16/2024 - 12/17/2024",
    status: "Pending",
    badge: "pending",
  },
  {
    type: "Early Leave",
    employee: "David Wilson",
    duration: "4 Hours",
    fromTo: "12/19/2024 - 12/19/2024",
    status: "Approved",
    badge: "approved",
  },
];

export default function SmartRequestManagement() {
  return (
    <section className="srm-wrap">
      {/* background */}
      {/* <div className="srm-bg-grad" /> */}
      <div className="srm-bg-orb" />

      <div className="srm-container">
        {/* header */}
        <div className="srm-head">
          {/* <div className="srm-pill">
                        <ClipboardCheck className="srm-pill-icon" />
                        <span className="srm-pill-text">Streamlined Approvals</span>
                    </div> */}

          <h3 className="srm-title">Smart Request Management</h3>
          <p className="srm-subtitle">
            Submit, track, and approve requests with ease
          </p>
        </div>

        {/* stats */}
        <div className="srm-stats">
          {STATS.map(({ label, value, Icon, tone }) => (
            <div className={`srm-stat tone-${tone}`} key={label}>
              <div className="srm-stat-top">
                <div>
                  <div className={`srm-stat-label tone-${tone}-text`}>
                    {label}
                  </div>
                  <div className="srm-stat-value">{value}</div>
                </div>

                <div className={`srm-stat-iconbox tone-${tone}-soft`}>
                  <Icon className={`srm-stat-icon tone-${tone}-text`} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* table */}
        <div className="srm-tableCard">
          <div className="srm-tableScroll">
            <table className="srm-table">
              <thead>
                <tr>
                  <th>Request Type</th>
                  <th>Employee</th>
                  <th>Duration</th>
                  <th>From - To</th>
                  <th>Status</th>
                  <th className="srm-th-actions">Actions</th>
                </tr>
              </thead>

              <tbody>
                {ROWS.map((r, idx) => (
                  <tr key={idx}>
                    <td className="srm-td-strong">{r.type}</td>
                    <td>{r.employee}</td>
                    <td>{r.duration}</td>
                    <td className="srm-td-muted">{r.fromTo}</td>
                    <td>
                      <span className={`srm-badge ${r.badge}`}>{r.status}</span>
                    </td>
                    <td>
                      <button className="srm-actionBtn" type="button">
                        <Eye className="srm-actionIcon" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile hint */}
          <div className="srm-mobileHint">
            Swipe horizontally to view full table →
          </div>
        </div>
      </div>
    </section>
  );
}
